import React from "react";
import styles from "./TableHeader.module.css";

export const TableHeader = ({ align, ...props }) => (
  <th
    {...props}
    data-align={align}
    className={[styles.TableHeader, props.className].join(" ")}
  />
);
